// Assets CDN Url
export const CDN_URL = 'https://assets.solar.com';

